import React from 'react';
import AntText, { TextProps } from 'antd/lib/typography/Text';

export default function Text({ children, ...props }: TextProps) {
  return <AntText {...props}>{children}</AntText>;
}
